module cr.events {
    eventModule.config([
        '$stateProvider',
        ($stateProvider:any) => {

            $stateProvider
                .state('xco',{
                    ncyBreadcrumb: {
                        label: "{{'XCO'|translate}}"
                    },
                    url: '/xco/:db',

                    resolve: {
                        raceList: ['xcoService','$stateParams', (xcoService,$stateParams:angular.ui.IStateParamsService) =>  xcoService.raceList($stateParams["db"])]
                    },
                    templateUrl:'modules/event/views/xco.html',
                    controller: 'xcoController',
                    controllerAs: 'ctrl'
                })
                .state('xco.race',{
                    url: '/:raceName',
                    ncyBreadcrumb: {
                        skip:true
                    },
                    resolve :  {
                        registration: ['xcoService','$stateParams', (xcoService,$stateParams:angular.ui.IStateParamsService) =>  xcoService.registration($stateParams["db"],$stateParams["raceName"])],
                        overview: ['xcoService','$stateParams', (xcoService,$stateParams:angular.ui.IStateParamsService) =>  xcoService.overview($stateParams["db"],$stateParams["raceName"])],
                    },
                    templateUrl:'modules/event/views/xcorace.html',
                    controller: 'xcoRaceController',
                    controllerAs: 'race'
                })
                .state('quickresults',{
                    ncyBreadcrumb: {
                        label: "{{'RESULTS'|translate}}"
                    },
                    url: '/quickresults/:eventId?rows&header&scroll',

                    resolve: {
                        eventView: [
                            '$stateParams',
                            'TrackingService',
                            ($stateParams:angular.ui.IStateParamsService, trackingService:ITrackingService) => {
                                return trackingService.getEventView($stateParams["eventId"]);
                            },
                        ],
                        reportList: ['$stateParams','ResultService',($stateParams:angular.ui.IStateParamsService, resultService:IResultService)=>{
                            return resultService.getReportList($stateParams['eventId']);
                        }]
                    },
                    templateUrl:'modules/event/views/quickresults.html',
                    controller: 'QuickResultsController',
                    controllerAs: 'ctrl'
                }).state('quickresults.group',{
                    url: '/group/:groupId?rows&header&speed',
                    ncyBreadcrumb: {
                        skip:true
                    },
                    resolve :  {
                        reportGroup:['reportList','$stateParams',(reportList,$stateParams)=>_.find(reportList,g=>(<any>g).Id==$stateParams.groupId)]
                    },
                    templateUrl:'modules/event/views/quickgroup.html',
                    controller: 'QuickGroupController',
                    controllerAs: 'grp'
                })
                .state('quickresults.group.report',{
                    url: '/report/:reportId',
                    ncyBreadcrumb: {
                        skip:true
                    },
                    resolve :  {
                        report:['reportGroup','$stateParams',(reportGroup,$stateParams)=>_.find(reportGroup.Reports,g=>(<any>g).Id==$stateParams.reportId)]
                    },
                    templateUrl:'modules/event/views/quickreport.html',
                    controller: QuickReportController,
                    controllerAs: 'rep'
                })                
                .state('quickresults.group.url',{
                    url: '/iframe/:reportId',
                    ncyBreadcrumb: {
                        skip:true
                    },
                    resolve :  {
                        report:['reportGroup','$stateParams',(reportGroup,$stateParams)=>_.find(reportGroup.Reports,g=>(<any>g).Id==$stateParams.reportId)]
                    },
                    templateUrl:'modules/event/views/quickiframe.html',
                    controller: QuickReportController,
                    controllerAs: 'rep'
                })                
                .state('quickresults.group.ligne',{
                    url: '/liveligne/:reportId',
                    ncyBreadcrumb: {
                        skip:true
                    },
                    resolve :  {
                        report:['reportGroup','$stateParams',(reportGroup,$stateParams)=>_.find(reportGroup.Reports,g=>(<any>g).Id==$stateParams.reportId)],
                        timingConfiguration: [
                            '$stateParams',
                            'TrackingService',
                            ($stateParams:angular.ui.IStateParamsService, trackingService:ITrackingService) => {
                                return trackingService.getTimingConfiguration($stateParams['eventId']);
                            }
                        ]                                               
                    },
                    templateUrl:'modules/event/views/quickliveligne.html',
                    controller: QuickLiveLigneController,
                    controllerAs: 'live'
                })                                
                .state('quickresults.group.report.video',{
                    url: '/video/:token',
                    ncyBreadcrumb: {
                        skip:true
                    },
                    resolve :  {
                        videoReferences:['$stateParams','ResultService',($stateParams,resultService)=>resultService.videoReferences($stateParams.token)]
                    },
                    views:
                    {
                        '@quickresults': {
                            templateUrl: 'modules/event/views/video.html',
                            controller: 'VideoController',
                            controllerAs: 'video'
                        }
                    }
                })
                .state('quickresults.group.report.video.content',{
                    url: '/:idx',
                    ncyBreadcrumb: {
                        skip:true
                    },
                    resolve :  {
                        videoLink:['$stateParams','ResultService','videoReferences',($stateParams,resultService,videoReferences)=>{
                            //console.log("request video link "+angular.toJson(videoReferences));
                            return resultService.videoLink($stateParams.eventId,videoReferences[$stateParams.idx]);
                        }]
                    },
                    templateUrl: 'modules/event/views/videocontent.html',
                    controller: 'VideoContentController',
                    controllerAs: 'videoContent'
                })
                .state('event', {
                    ncyBreadcrumb: {
                        label: "{{'EVENT'|translate}}"
                    },
                    url: '/event/:eventId',
                    abstract:true,
                    resolve: {
                        eventView: [
                            '$stateParams',
                            'TrackingService',
                            ($stateParams:angular.ui.IStateParamsService, trackingService:ITrackingService) => {
                                return trackingService.getEventView($stateParams["eventId"]);
                            }
                        ]
                    },
                    views:{
                        "":{
                            templateUrl:'modules/event/views/event-template.html',
                            controller: 'EventController'
                        }
                    },
                    controllerAs: 'eventController'
                })
                .state('event.home', {
                    url: '',
                    views:{
                        '': {
                            templateUrl: 'modules/event/views/event-home.html',
                            controller: 'EventController'
                        }
                    },
                    ncyBreadcrumb: {
                        skip:true
                    }
                })
                .state('event.custom',
                  {
                    url:"/custom",
                    template:"<ui-view/>"
                  }
                )
                .state('event.custom.tenkm',
                  {
                    url:"/tenkm",
                    templateUrl:"modules/event/views/tenkm-home.html"
                  }
                )
                .state('event.participants', {
                    url: '/participants',
                    views:{
                        "title": { template:"<span translate>PARTICIPANTS</span>"},
                        '': {
                            templateUrl: 'modules/event/views/event-participant.html',
                            controller: 'EventController'
                        }
                    },
                    ncyBreadcrumb: {
                        label: "{{'PARTICIPANTS'|t}}"
                    }

                })
                .state('event.reports',{
                    url:'/reports',
                    abstract:true,
                    resolve:{
                        reportList: ['$stateParams','ResultService',($stateParams:angular.ui.IStateParamsService, resultService:IResultService)=>{
                            return resultService.getReportList($stateParams['eventId']);
                        }],
                        breadcrumb: ()=> "#REPORTS"
                    },
                    views : {
                        "title": { template: "<span translate>RESULTS</span>"},
                        '': {
                            templateUrl: 'modules/event/views/result-template.html',
                            controller: 'resultController',
                            controllerAs: 'ctrl'
                        }
                    },
                    ncyBreadcrumb: {
                        label: "{{'RESULTS'|translate}}"
                    }
                }).state('event.reports.home',{
                    url:''
                    ,views:{
                        '': {
                            templateUrl: 'modules/event/views/result-home.html'
                        }
                    },
                    ncyBreadcrumb: {
                        skip:true
                    }

                }).state("event.reports.group",{
                    url:'/group/:groupId',
                    abstract:true,
                    templateUrl: 'modules/event/views/result-group.html',
                    ncyBreadcrumb: {
                        label: '{{curGroup.DisplayName|tc}}'

                    },
                    views:{
                        '':{template:"<ui-view/>"}/*,
                        "title@event": {
                            template: "<span translate>{{curGroup.DisplayName|tc}}</span>"}*/

                    },
                    data:{
                        proxy:'event.reports.group.home'
                    }
                }).state("event.reports.group.home",{
                    url:'',
                    ncyBreadcrumb: {
                        skip: true
                        //,parent:"event.reports"
                    },
                    views:{
                        '': {
                            templateUrl: 'modules/event/views/result-group-home.html',
                            controller:'resultController'
                        }
                    }
                }).state("event.reports.group.report",{
                    url:'/report/:reportId',
                    ncyBreadcrumb: {
                        label: '{{curReport.DisplayName|tc}}'
                        //,parent:"event.reports"
                    },
                    views:{
                        '': {
                            templateUrl: 'modules/event/views/result-group-report.html',
                            controller:'resultController'
                        }
                    }
                })

                .state('event.ligneresults', {
                    url: '/ligneresults',
                    abstract:true,
                    resolve: {
                        timingConfiguration: [
                            '$stateParams',
                            'TrackingService',
                            ($stateParams:angular.ui.IStateParamsService, trackingService:ITrackingService) => {
                                return trackingService.getTimingConfiguration($stateParams['eventId']);
                            }
                        ]
                    },

                    views: {
                        "title": { template: "<span translate>RESULTS</span>"},

                        '': {
                            templateUrl: 'modules/event/views/live-ligne-template.html',
                            controller: LiveLigneController,
                            controllerAs: 'liveController'
                        }
                    }
                }).state('event.ligneresults.home',{
                    url:''
                    ,views:{
                        '': {
                            templateUrl: 'modules/event/views/live-ligne-home.html'
                        }
                    }
                }).state('event.ligneresults.group',{
                    url:'/group/:groupId'
                    ,templateUrl:'modules/event/views/live-ligne-group.html'
                    ,controller: LiveLigneGroupController
                    ,controllerAs: 'liveGroupController'
                    ,resolve:{                        
                        group:['$stateParams','timingConfiguration',($stateParams,timingConfiguration)=>{
                            console.log("group: "+$stateParams.groupId);
                            return _.where(timingConfiguration.ResultGroups,{GroupId:Number($stateParams.groupId)})[0];
                        }]
                    }   
                }).state('event.ligneresults.group.overview',{
                    url:'/overview'
                    ,templateUrl:'modules/event/views/live-ligne-overview.html'
                })
                .state('event.ligneresults.my',{
                    url:'/my/:bib'
                    ,resolve: {
                        resultDetail: [
                            '$stateParams',
                            'TrackingService',
                            ($stateParams:angular.ui.IStateParamsService, trackingService:ITrackingService) => {
                                return trackingService.getBibDetails($stateParams['eventId'],$stateParams['bib']);
                            }
                        ]
                    }
                    ,templateUrl: 'modules/event/views/my-result.html'
                    ,controller: "myResultController"

                })
                /*.state('event.ligneresults.group', {
                    url: '/group/:groupId',
                    templateUrl: 'modules/event/views/result-group.html',
                    controller: "resultGroupController",
                    resolve:{
                        Overview:['$stateParams','TrackingService',($stateParams:angular.ui.IStateParamsService, trackingService:ITrackingService) => {
                            return trackingService.getOverview($stateParams['eventId'],$stateParams['groupId']);
                        }
                        ]
                    }

                })
                .state('event.ligneresults.group.home', {
                    url: '/home',
                    templateUrl: 'modules/event/views/result-group-home.html'
                })

                .state('event.ligneresults.group.split',{
                    templateUrl: 'modules/event/views/result-group-split.html',
                    url:'/split',
                    abstract:true
                })
                .state('event.ligneresults.group.split.overview',{
                    templateUrl: 'modules/event/views/result-group-overview.html',
                    url:''
                })
                .state('event.ligneresults.group.split.detail',{
                    url:'/:splitName',
                    controller: "resultGroupController",

                    templateUrl: 'modules/event/views/result-group-split-detail.html'
                })*/
                .state('tracking', {
                    url: '/live/tracking/:eventId',

                    resolve: {
                        eventView: [
                            '$stateParams',
                            'TrackingService',
                            ($stateParams:angular.ui.IStateParamsService, trackingService:ITrackingService) => {
                                return trackingService.getEventView($stateParams['eventId']);
                            }
                        ],
                        gpsConfiguration: ['$stateParams','TrackingService',($stateParams,trackingService)=>{
                            return trackingService.gpsConfiguration($stateParams['eventId']);
                        }]
                    },
                    templateUrl:'modules/event/views/tracking-index.html',
                    controller: 'TrackingController',
                    controllerAs: 'track'

                })
        }
    ]);
}
